var React = require('react');

function DownloadSimple (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m448.61 351.79c-18.444 0-33.4 14.952-33.4 33.396v52.055h-318.42v-52.055c0-18.443-14.952-33.396-33.396-33.396s-33.396 14.952-33.396 33.396v85.451c0 18.443 14.952 33.4 33.396 33.4h385.22c18.443 0 33.396-14.957 33.396-33.4v-85.451c0-18.444-14.953-33.396-33.397-33.396z","key":0}),React.createElement("path",{"d":"m245.92 387.32c5.563 5.559 14.6 5.559 20.157 0l117.04-117.04c3.41-3.41 4.423-8.532 2.579-13-1.844-4.45-6.18-7.351-11.012-7.351h-54.954v-215.91c0-14.402-11.661-26.063-26.06-26.063h-75.323c-14.398 0-26.06 11.66-26.06 26.063v215.91h-54.973c-4.827 0-9.163 2.9-11.007 7.351-1.844 4.468-0.83 9.59 2.575 13l117.04 117.04z","key":1})]);
}

DownloadSimple.defaultProps = {"version":"1.1","viewBox":"0 0 512 512","xmlSpace":"preserve"};

module.exports = DownloadSimple;

DownloadSimple.default = DownloadSimple;
